import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: pp81381
 * id DCA776E3-A4EF-4B2F-A3F4-D8BEC9236502
 * name projector-screen-variant-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/projector-screen-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const ProjectorScreenVariantOutlineIcon = createSvgIcon(<><path d="M20 6H4C3.45 6 3 6.45 3 7V8C3 8.55 3.45 9 4 9H5V18H19V9H20C20.55 9 21 8.55 21 8V7C21 6.45 20.55 6 20 6M17 16H7V9H17V16Z" /></>, 'ProjectorScreenVariantOutlineIcon');
export default ProjectorScreenVariantOutlineIcon